const ACTION_LABELS = {
  register_bonus: '注册赠送',
  wechat_follow_bonus: '关注送积分',
  forum_post_bonus: '论坛发帖',
  daily_login_bonus: '每日登录',
  catalog_task: '选型任务',
  catalog_advise: '选型推荐',
  catalog_search: '参数查询',
  price_search: '卡价库查询',
  bid_analyze: '招标分析',
  bom_estimate: '服务器估价',
  purchase_tokens: '充值 Token',
  admin_grant: '人工补点'
}

export function actionLabel(action) {
  return ACTION_LABELS[action] || action
}

export function formatLedgerTime(iso) {
  if (!iso) return ''
  return iso.replace('T', ' ').slice(0, 19)
}
